module.exports = __webpack_public_path__ + "img/source_book-item16.e4ae7707.png";